import {
    Calendar,
    ConciergeBell,
    LayoutDashboard,
    ListChecks,
    LucideIcon,
    ShieldAlert,
    UserSearch,
} from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { openPatientSpotlight } from '@/components/searchPatient/patient-spotlight-store.ts';
import { SearchPatientSpotlight } from '@/components/searchPatient/search-patient-spotlight.tsx';

import { AppRoute } from '@/constants/app-routes.ts';

import { useGlobalHotkeys } from '@/hooks/use-global-hotkeys.ts';
import useAuth from '@/hooks/useAuth.ts';
import useBreakpoints from '@/hooks/useBreakpoints.ts';
import useConfig from '@/hooks/useConfig.ts';

import { UserEntitlement, UserGroup } from '@/models/User.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';

import Icon from './Icon.tsx';
import NavLink from './NavLink.tsx';

export const HeaderNavigation = () => {
    const { isUserInGroup } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { configs } = useConfig();
    const { is_lg: isLg } = useBreakpoints();

    useGlobalHotkeys();

    const links: { label: string; icon: LucideIcon; path: AppRoute }[] = [
        {
            label: 'Termine',
            icon: ConciergeBell,
            path: AppRoute.ROOT,
        },
        {
            label: 'Kalender',
            icon: Calendar,
            path: AppRoute.CALENDAR_VIEW,
        },
    ];

    const isTaskViewRendered = configs.some((config) => config.pvs_provider === PVSProvider.DOC_CIRRUS);
    if (isTaskViewRendered) {
        links.push({
            label: 'Aufgaben',
            icon: ListChecks,
            path: AppRoute.TASKS,
        });
    }

    if (isUserInGroup(UserGroup.FEATURE_CAREVIEW)) {
        links.push({
            label: 'CareView',
            icon: LayoutDashboard,
            path: AppRoute.CAREVIEW,
        });
    }

    if (isUserInGroup(UserEntitlement.ENTITLEMENT_BOOKING_SHIELD)) {
        links.push({
            label: 'BookingShield',
            icon: ShieldAlert,
            path: AppRoute.BOOKING_SHIELD,
        });
    }

    return (
        <div className="flex items-center gap-1 xl:gap-8">
            {links.map(({ label, path, icon }) => (
                <NavLink
                    onClick={() => navigate(path)}
                    active={location.pathname === (path as string)}
                    key={path}
                    leftSection={isLg && <Icon icon={icon} />}
                    label={label}
                />
            ))}
            <NavLink
                label="Patient:innen"
                onClick={openPatientSpotlight}
                leftSection={isLg && <Icon icon={UserSearch} />}
                active={false}
            />
            <SearchPatientSpotlight />
        </div>
    );
};
